/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="16.9"
        viewBox="0 0 19 16.9"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M16.19 10.5C18.01 8.5 19 7.05 19 4.81a5 5 0 0 0-5.13-4.84A5.83 5.83 0 0 0 9.5 2.14 5.83 5.83 0 0 0 5.12-.03 4.94 4.94 0 0 0 0 4.81c0 2.24 1 3.73 2.81 5.69 1.67 1.8 6.16 5.9 6.35 6.07l.33.3.34-.3c.19-.15 4.68-4.23 6.36-6.07Zm-6.69 5c-1.17-1.07-4.57-4.22-6-5.7C1.81 7.99.96 6.71.96 4.8a3.92 3.92 0 0 1 1.25-2.78A4 4 0 0 1 5.08.96a5.07 5.07 0 0 1 4 2.27l.43.7.42-.7A5.08 5.08 0 0 1 13.88.96a4 4 0 0 1 4.13 3.84c0 1.92-.86 3.2-2.54 5-1.39 1.53-4.8 4.7-5.97 5.75Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'HeartIcon';

export default Icon;
